import { ForgeButton, ForgeDialog, ForgeScaffold, ForgeStack, ForgeToolbar } from '@tylertech/forge-react';

export default function ConfirmActionDialog({ open, title, message, confirmText, onClose, onConfirm, isSubmitting }) {
  const handleClose = () => {
    if (isSubmitting) return;
    onClose();
  };

  return (
    <ForgeDialog className="dialog--small" open={open} label={title} on-forge-dialog-close={handleClose}>
      <ForgeScaffold>
        <ForgeToolbar slot="header" className="dialog-header">
          <h2 slot="start" className="forge-typography--subheading6">
            {title}
          </h2>
        </ForgeToolbar>
        <div slot="body" className="dialog-body">
          <p dangerouslySetInnerHTML={{ __html: message }} />
        </div>
        <ForgeToolbar slot="footer" inverted>
          <ForgeStack slot="end" inline>
            <ForgeButton variant="outlined" onClick={handleClose} disabled={isSubmitting}>
              Cancel
            </ForgeButton>
            <ForgeButton variant="filled" onClick={onConfirm} disabled={isSubmitting}>
              {confirmText}
            </ForgeButton>
          </ForgeStack>
        </ForgeToolbar>
      </ForgeScaffold>
    </ForgeDialog>
  );
}
